import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import companyReducer from './companyReducer';
import localeReducer from './localeReducer';
import productReducer from './productReducer';
import infoReducer from './infoReducer';
import homeImageReducer from './homeImageReducer';

export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  company: companyReducer,
  product: productReducer,
  info: infoReducer,
  homeImage: homeImageReducer,
  locale: localeReducer,
});
